import React from 'react'
import i18next from 'i18next'
import { DataListItem } from '@node-space/ui-components'

interface BuySellProps {
  fromAmount: string
  amountReceived: string
  sourceWallet: string
  destinationWallet: string
  senderCurrency: string
  beneficiaryCurrency: string
  exchangeRate: number
  transactionDate: string
}

const BuySell = ({
  fromAmount,
  amountReceived,
  sourceWallet,
  destinationWallet,
  senderCurrency,
  beneficiaryCurrency,
  exchangeRate,
  transactionDate,
}: BuySellProps) => {
  return (
    <>
      {fromAmount && (
        <DataListItem
          id="from-amount"
          testId="from-amount"
          title={i18next.t('transactions.sideBar.fromAmount')}
          body={fromAmount}
        />
      )}
      {amountReceived && (
        <DataListItem
          id="amount-received"
          testId="amount-received"
          title={i18next.t('transactions.sideBar.amountReceived')}
          body={amountReceived}
        />
      )}
      {sourceWallet && (
        <DataListItem
          id="source-wallet"
          testId="source-wallet"
          title={i18next.t('transactions.sideBar.sourceWallet')}
          body={sourceWallet}
        />
      )}
      {destinationWallet && (
        <DataListItem
          id="destination-wallet"
          testId="destination-wallet"
          title={i18next.t('transactions.sideBar.destinationWallet')}
          body={destinationWallet}
        />
      )}
      {!!exchangeRate && (
        <DataListItem
          id="exchange-rate"
          testId="exchange-rate"
          title={i18next.t('transactions.sideBar.exchangeRate')}
          body={`1 ${senderCurrency} = ${exchangeRate} ${beneficiaryCurrency}`}
        />
      )}
      {transactionDate && (
        <DataListItem
          id="transaction-date"
          testId="transaction-date"
          title={i18next.t('date')}
          body={transactionDate}
        />
      )}
    </>
  )
}

export default BuySell
